import { yupResolver } from "@hookform/resolvers/yup";
import { Dispatch } from "react";
import {
  useTranslate,
  Edit,
  TextInput,
  SimpleForm,
  useUpdate,
  Toolbar,
  SaveButton
} from "react-admin";
import * as yup from "yup";
import { IShowAppointmentServiceDialogData } from "./AppointmentServiceList";

interface AppointmentServiceEditProps {
  editDialogId: string;
  closeEditDialog: () => void;
  setShowDialogData: Dispatch<
    React.SetStateAction<IShowAppointmentServiceDialogData | null>
  >;
}

function CustomToolbar({
  editDialogId,
  closeEditDialog,
  setShowDialogData
}: AppointmentServiceEditProps) {
  const [edit] = useUpdate();
  const translate = useTranslate();

  const handleDelete = () => {
    edit(
      "Appointment",
      {
        id: editDialogId,
        data: { notes: "" }
      },
      {
        onSuccess: () => {
          setShowDialogData((prev: IShowAppointmentServiceDialogData | null) =>
            prev
              ? {
                  ...prev,
                  appointmentNotes: ""
                }
              : null
          );
          closeEditDialog();
        }
      }
    );
  };

  return (
    <Toolbar
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between"
      }}
    >
      <SaveButton />
      <div
        className="text-error cursor-pointer text-[16px] font-['Inter'] font-[600]|"
        onClick={handleDelete}
        aria-hidden
      >
        {translate("common.remove")}
      </div>
    </Toolbar>
  );
}

export default function AppointmentServiceEdit({
  editDialogId,
  closeEditDialog,
  setShowDialogData
}: AppointmentServiceEditProps) {
  const translate = useTranslate();
  const [edit] = useUpdate();
  const submit = (data: any) => {
    edit(
      "Appointment",
      {
        id: editDialogId,
        data: { notes: data.notes ? data.notes : "" }
      },
      {
        onSuccess: () => {
          setShowDialogData((prev: IShowAppointmentServiceDialogData | null) =>
            prev
              ? {
                  ...prev,
                  appointmentNotes: data.notes ? data.notes : ""
                }
              : null
          );
          closeEditDialog();
        }
      }
    );
  };

  return (
    <Edit
      id={editDialogId}
      resource="Appointment"
      actions={<div style={{ height: "0px" }} />}
      sx={{
        backgroundColor: "#fff",
        "& .RaToolbar-desktopToolbar": {
          backgroundColor: "#fff",
          gap: "8px",
          minHeight: "40px",
          padding: "0px 16px 16px 16px"
        },
        "& .RaEdit-noActions": {
          marginTop: 0
        }
      }}
    >
      <SimpleForm
        resolver={yupResolver(validationSchema)}
        onSubmit={submit}
        toolbar={
          <CustomToolbar
            editDialogId={editDialogId}
            closeEditDialog={closeEditDialog}
            setShowDialogData={setShowDialogData}
          />
        }
        sx={{ backgroundColor: "#fff", padding: "0px 16px !important" }}
      >
        <TextInput
          source="notes"
          label={translate("appointment.notes")}
          fullWidth
          multiline
        />
      </SimpleForm>
    </Edit>
  );
}

const validationSchema = yup
  .object()
  .shape({
    notes: yup.string().nullable()
  })
  .required();
